import type { NuxtError } from '#app'
import type { AuthResponse } from '~/types/auth'

export const useStoreAuth = defineStore('auth', () => {
  const authCustomerToken = ref<string | null>(null)

  const isAuthenticated = computed(() => tokenInfo.value?.customer_id !== null && !isTokenExpired.value)

  const getJwtToken = () => {
    return authCustomerToken.value
  }

  const setJwtToken = (token: string) => {
    authCustomerToken.value = token
  }

  const tokenInfo = computed(() => {
    const token = authCustomerToken.value

    if (!token) return null

    return JSON.parse(atob(token.split('.')[1]))
  })

  const isTokenExpired = computed(() => {
    if (tokenInfo.value === null) return true

    return tokenInfo.value.exp < Date.now() / 1000
  })

  const refreshToken = async (companyId: number, customerId?: string | null) => {
    const body: { company_id: number; external_id?: string } = {
      company_id: companyId
    }

    if (customerId) {
      body.external_id = customerId
    }

    try {
      const refreshToken: AuthResponse = await useNuxtApp().$api(`/customers/jwt/`, {
        method: 'POST',
        body
      })
      authCustomerToken.value = refreshToken.token
    } catch (error) {
      const { statusCode } = error as NuxtError
      showError({ statusCode })
    }
  }

  const authenticateFromStore = async (companyId: number, customerId?: string) => {
    let cust = null

    if (customerId && customerId !== 'undefined' && customerId !== 'null' && customerId !== '0') {
      cust = customerId
    }

    if (
      isTokenExpired.value ||
      (tokenInfo.value?.customer_id === null && cust !== null) ||
      (tokenInfo.value?.customer_id !== null && cust === null)
    ) {
      await refreshToken(companyId, cust)
    }
  }

  const logout = () => {
    const { companyId } = useStoreApp()
    refreshToken(companyId)
  }

  return {
    logout,
    isAuthenticated,
    getJwtToken,
    setJwtToken,
    refreshToken,
    tokenInfo,
    authenticateFromStore
  }
})
